import { useDefaultSortingItem } from 'src/hooks'
import { useLocales } from 'src/locales'

export const useRecipesConfig = () => {
  const { t } = useLocales()

  const { defaultSortingOption } = useDefaultSortingItem()

  const options = [
    defaultSortingOption,
    {
      value: 'dateIssued',
      label: t('recipes.date_issued_asc')
    },
    {
      value: '-dateIssued',
      label: t('recipes.date_issued_desc')
    },
    {
      value: 'dispensingDate',
      label: t('recipes.date_dispensing_asc')
    },
    {
      value: '-dispensingDate',
      label: t('recipes.date_dispensing_desc')
    }
  ]

  return { options }
}
